import { useState } from 'react'
import ReactPaginate from 'react-paginate'

import { IconChevronLeft, IconChevronRight } from '@avantstay/backoffice-vectors'

import { PaginateProps, PaginationSizeOption } from '../../components/Paginate/_types'
import { iconsStyles } from '../../components/Paginate/Paginate.styles'
import { pluralize } from '../../utils'
import { numberWithCommas } from '../../utils/format'
import { useIsMobile } from '../../utils/mediaQueries'
import { SelectField } from '../SelectField'
import * as S from './Paginate.styles'
import { itemsPerPageOptions } from './Paginate.utils'

// Keep this export clean, free of wrapping HOCs

// If you need to wrap this component with HOCs, use them here
export function Paginate({
  className,
  onPageChange,
  onPaginationSizeChange,
  pageCount = 1,
  initialPage = 1,
  totalResults,
  paginationSize,
  disableCentering,
  hideAdditionalPageNumbers,
  hidePageNumbers,
  hideTotal,
  hidePaginationSizeSelector,
}: PaginateProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const isMobile = useIsMobile()

  const itemsPerPage = paginationSize
    ? {
        label: paginationSize,
        value: paginationSize,
      }
    : undefined

  const getPageRangeDisplayed = () => {
    if (hidePageNumbers || hideAdditionalPageNumbers) {
      return 0
    }
    return 4
  }

  const startCount = (initialPage - 1) * (paginationSize || 0) + 1
  const endCount =
    initialPage < pageCount
      ? (Number(initialPage) - 1) * Number(paginationSize) + Number(paginationSize)
      : totalResults

  return (
    <S.PaginateContainer
      justifyCenter={itemsPerPage === undefined}
      isMobile={isMobile}
      className={className}
    >
      {!disableCentering && itemsPerPage && !isMobile ? <S.EmptyDiv /> : null}
      <S.PaginationContainer
        isMobile={isMobile}
        hideAdditionalPages={hidePageNumbers || hideAdditionalPageNumbers}
        hidePages={hidePageNumbers}
      >
        <ReactPaginate
          forcePage={initialPage - 1}
          disableInitialCallback
          previousLabel={<IconChevronLeft style={iconsStyles} />}
          nextLabel={<IconChevronRight style={iconsStyles} />}
          breakLabel="..."
          disabledClassName="disabled"
          breakClassName="paginationEllipsis"
          pageCount={pageCount}
          marginPagesDisplayed={hidePageNumbers || hideAdditionalPageNumbers ? 0 : 1}
          pageRangeDisplayed={getPageRangeDisplayed()}
          onPageChange={({ selected }: { selected: number }) => onPageChange(selected)}
          containerClassName="pagination"
          activeClassName="active"
          pageLinkClassName="paginationLink"
        />
      </S.PaginationContainer>
      {!isMobile && itemsPerPage ? (
        <S.SelectPageItemsContainer isMenuOpen={isMenuOpen} isMobile={isMobile}>
          {totalResults !== undefined && !hideTotal ? (
            <S.ResultsWrapper>
              {totalResults !== undefined && paginationSize ? (
                <>
                  <b>{`${numberWithCommas(startCount || 0)}-${numberWithCommas(endCount || 0)}`}</b>
                  of
                  <b>{numberWithCommas(totalResults)}</b>
                  {pluralize(totalResults, 'results', 'result')}
                </>
              ) : null}
            </S.ResultsWrapper>
          ) : null}
          {!hidePaginationSizeSelector && (
            <S.SelectFieldWrapper>
              <span>SHOW</span>
              <SelectField.Small
                menuPlacement="top"
                isSearchable={false}
                removeBorder
                menuPosition="sticky"
                onMenuClose={() => setIsMenuOpen(false)}
                onMenuOpen={() => setIsMenuOpen(true)}
                onChange={option => {
                  onPaginationSizeChange?.((option as PaginationSizeOption).value)
                }}
                value={itemsPerPage}
                options={itemsPerPageOptions}
              />
            </S.SelectFieldWrapper>
          )}
        </S.SelectPageItemsContainer>
      ) : null}
    </S.PaginateContainer>
  )
}
